export default "__VITE_ASSET__CRMLEggE__"